import { gql } from '@apollo/client/core';
import { CoreDocumentFieldsFragmentDoc } from '@generatedTypes';

export const UPLOAD_ATTACHMENTS = gql`
  mutation UploadAttachments($input: UploadAttachmentsInput!) {
    uploadAttachments(input: $input) {
      comment
      file
      type
    }
  }
`;

export const DELETE_ATTACHMENT = gql`
  mutation DeleteAttachment($input: DeleteAttachmentInput!) {
    deleteAttachment(input: $input) {
      id
    }
  }
`;

export const UPLOAD_SIGNING_SHEET = gql`
  ${CoreDocumentFieldsFragmentDoc}
  mutation UploadSigningSheet($input: UploadSigningSheetInput!) {
    uploadSigningSheet(input: $input) {
      id
      name
      document {
        ...CoreDocumentFields
      }
    }
  }
`;

export const CREATE_ATTENDEE_CONTRACT = gql`
  mutation CreateContractAttendee($input: CreateContractAttendeeInput!) {
    createContractAttendee(input: $input) {
      batch_id
      attendee_id
      contract_template_id
    }
  }
`;

export const EDIT_CONTRACT_ATTENDEE = gql`
  mutation EditContractAttendeeInput($input: EditContractAttendeeInput!) {
    editContractAttendee(input: $input)
  }
`;
